import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import WebLogo from "./WebLogo";
import { NavLink } from "react-router-dom";
import "./Header.scss";
import { uiActions } from "../store/ui-slice";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const skin = useSelector((state) => state.ui.skin);
  const loading = useSelector((state) => state.pages.loadingData);
  const dispatch = useDispatch();

  const toggleThemeSkin = () => {
    dispatch(uiActions.toggleSkin());
  };

  const toggleMenu = () => {
    dispatch(uiActions.toggleMenu());
  };

  const toggleContact = () => {
    dispatch(uiActions.toggleContact());
  };

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header-container ${isSticky ? "sticky" : ""} ${loading ? "loading" : ""}`}>
      <Menu />
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-6"}>
            <div className={"logo-container"}>
              <NavLink to={"/"}>
                <WebLogo />
              </NavLink>
              <label className="switch">
                <input
                  type="checkbox"
                  defaultChecked={skin === "light"}
                  onChange={toggleThemeSkin}
                />
                <span className="slider round"></span> <small>{skin}</small>
              </label>
            </div>
          </div>
          <div className={"col-6"}>
            <div className={"menu-element text-right"}>
              <NavLink
                onClick={toggleContact}
                to="#"
                className={({ isActive }) =>
                  isActive ? "fancy selected" : "fancy"
                }>
                TALK TO US
              </NavLink>
              <span className={"menu-button"} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
